var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-container" },
    [
      _c("header", { staticClass: "page-header" }, [
        _c(
          "div",
          { staticClass: "d-flex align-items-center" },
          [
            _c("portal-target", {
              staticClass: "d-flex align-items-center mt-1",
              attrs: { name: "sidebar-toggle" }
            }),
            _vm._v(" "),
            _c("h4", { staticClass: "mb-0" }, [_vm._v(_vm._s(_vm.title))])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "d-flex align-items-center" },
          [
            _c("export-sidebar", {
              attrs: {
                "sidebar-id": "sidebar-workers-export",
                "storage-key": "sidebar_workers_export",
                columns: _vm.exportableFields,
                "data-to-export": _vm.dataToExport,
                "data-mapper": _vm.mapWorkerForExport,
                "file-name": "Workers.xlsx",
                "sheet-name": "Workers",
                "is-busy": _vm.isBusy,
                "items-count": _vm.totalRows
              }
            }),
            _vm._v(" "),
            _c(
              "b-button",
              {
                directives: [
                  {
                    name: "b-toggle",
                    rawName: "v-b-toggle.sidebar-fields",
                    modifiers: { "sidebar-fields": true }
                  }
                ],
                staticClass: "custom-btn-secondary mr-1",
                attrs: { id: "table-settings" }
              },
              [_c("v-icon", { attrs: { name: "buttons/cog", size: 13 } })],
              1
            ),
            _vm._v(" "),
            _c(
              "b-tooltip",
              {
                attrs: {
                  target: "table-settings",
                  triggers: "hover",
                  "custom-class": "custom-tooltip",
                  noninteractive: ""
                }
              },
              [_vm._v("\n        Колонки\n      ")]
            ),
            _vm._v(" "),
            _vm.canEditWorkers()
              ? _c(
                  "b-button",
                  {
                    staticClass: "custom-btn-primary",
                    attrs: { disabled: _vm.isBusy },
                    on: {
                      click: function($event) {
                        return _vm.onCreate()
                      }
                    }
                  },
                  [
                    _vm.isBusy
                      ? _c("b-spinner", { attrs: { small: "" } })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("v-icon", { attrs: { name: "buttons/plus", size: 12 } }),
                    _vm._v("\n        Новый исполнитель\n      ")
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "page-body" },
        [
          _c(
            "div",
            { staticClass: "page-filters" },
            [
              _c(
                "filters-drawer",
                {
                  attrs: {
                    query: _vm.filters.query,
                    "is-busy": _vm.isBusy,
                    "filter-tags": _vm.activeFilterTags
                  },
                  on: {
                    "update:query": function($event) {
                      return _vm.$set(_vm.filters, "query", $event)
                    },
                    "remove-tag": _vm.removeFilterTag,
                    submit: _vm.onSearch,
                    clear: _vm.onClearFilters
                  }
                },
                [
                  _c(
                    "b-col",
                    { attrs: { md: "6", cols: "12" } },
                    [
                      _c("label", { staticClass: "small text-muted" }, [
                        _vm._v("Города")
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-form-select",
                        {
                          attrs: { id: "input-town", size: "sm" },
                          model: {
                            value: _vm.filters.town,
                            callback: function($$v) {
                              _vm.$set(_vm.filters, "town", $$v)
                            },
                            expression: "filters.town"
                          }
                        },
                        [
                          _c("option", { domProps: { value: -1 } }, [
                            _vm._v("Все города")
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.towns, function(option) {
                            return _c(
                              "option",
                              { domProps: { value: option.id } },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(option.name) +
                                    "\n            "
                                )
                              ]
                            )
                          })
                        ],
                        2
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { md: "6", cols: "12" } },
                    [
                      _c("label", { staticClass: "small text-muted" }, [
                        _vm._v("Уровень КПД")
                      ]),
                      _vm._v(" "),
                      _c("b-form-select", {
                        attrs: {
                          id: "input-level-efficiency",
                          size: "sm",
                          options: _vm.levelEfficiencyOptions
                        },
                        model: {
                          value: _vm.filters.level_efficiency,
                          callback: function($$v) {
                            _vm.$set(_vm.filters, "level_efficiency", $$v)
                          },
                          expression: "filters.level_efficiency"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { md: "6", cols: "12" } },
                    [
                      _c("label", { staticClass: "small text-muted" }, [
                        _vm._v("Активные")
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-form-select",
                        {
                          attrs: { id: "input-active", size: "sm" },
                          model: {
                            value: _vm.filters.active,
                            callback: function($$v) {
                              _vm.$set(_vm.filters, "active", $$v)
                            },
                            expression: "filters.active"
                          }
                        },
                        [
                          _c("option", { domProps: { value: null } }, [
                            _vm._v("Показывать все")
                          ]),
                          _vm._v(" "),
                          _c("option", { domProps: { value: true } }, [
                            _vm._v("Активные")
                          ]),
                          _vm._v(" "),
                          _c("option", { domProps: { value: false } }, [
                            _vm._v("Удалённые")
                          ])
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { md: "6", cols: "12" } },
                    [
                      _c("label", { staticClass: "small text-muted" }, [
                        _vm._v("Статус")
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-form-select",
                        {
                          attrs: { id: "input-status", size: "sm" },
                          model: {
                            value: _vm.filters.status_id,
                            callback: function($$v) {
                              _vm.$set(_vm.filters, "status_id", $$v)
                            },
                            expression: "filters.status_id"
                          }
                        },
                        [
                          _c("option", { domProps: { value: null } }, [
                            _vm._v("Все статусы")
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.workerStatuses, function(option) {
                            return _c(
                              "option",
                              { domProps: { value: option.id } },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(option.name) +
                                    "\n            "
                                )
                              ]
                            )
                          })
                        ],
                        2
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.isBusy || (_vm.items && _vm.items.length > 0)
            ? [
                _c(
                  "div",
                  { staticClass: "page-table-container" },
                  [
                    _c("b-table", {
                      ref: "workers",
                      staticClass: "custom-table text-small mb-0",
                      attrs: {
                        id: "workers",
                        "tbody-tr-class": _vm.tbodyRowClass,
                        "sticky-header": "",
                        "select-mode": "multi",
                        responsive: "",
                        busy: _vm.isBusy,
                        items: _vm.items,
                        fields: _vm.renderedFields,
                        "no-provider-filtering": "",
                        "no-provider-paging": "",
                        "no-provider-sorting": "",
                        "no-local-sorting": ""
                      },
                      on: {
                        "sort-changed": _vm.sortChanged,
                        "row-clicked": _vm.onRowClicked,
                        "row-dblclicked": _vm.onRowDblClicked
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "table-busy",
                            fn: function() {
                              return [
                                _c("tables-skeleton", {
                                  attrs: { fields: _vm.renderedFields, rows: 5 }
                                })
                              ]
                            },
                            proxy: true
                          },
                          {
                            key: "head(selected)",
                            fn: function(row) {
                              return [
                                _c("b-form-checkbox", {
                                  staticClass: "mx-1",
                                  attrs: {
                                    indeterminate: _vm.indeterminate,
                                    size: "md"
                                  },
                                  on: { change: _vm.selectPageRows },
                                  model: {
                                    value: _vm.allSelected,
                                    callback: function($$v) {
                                      _vm.allSelected = $$v
                                    },
                                    expression: "allSelected"
                                  }
                                })
                              ]
                            }
                          },
                          {
                            key: "cell(selected)",
                            fn: function(row) {
                              return [
                                _c("b-form-checkbox", {
                                  staticClass: "mx-1",
                                  attrs: {
                                    size: "md",
                                    checked: row.item.selected
                                  },
                                  on: {
                                    change: function($event) {
                                      return _vm.onRowClicked(row.item)
                                    }
                                  },
                                  nativeOn: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                    }
                                  }
                                })
                              ]
                            }
                          },
                          {
                            key: "cell(risk)",
                            fn: function(row) {
                              return [
                                _c("worker-risk", {
                                  attrs: {
                                    "employment-type": row.item.employment_type,
                                    risk: _vm.workerRisks[row.item.id]
                                  }
                                })
                              ]
                            }
                          },
                          {
                            key: "cell(status_id)",
                            fn: function(row) {
                              return [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      row.item.status_name ||
                                        _vm.getStatusText(row.item.status_id)
                                    ) +
                                    "\n          "
                                )
                              ]
                            }
                          },
                          {
                            key: "cell(phone)",
                            fn: function(row) {
                              return [
                                _c(
                                  "div",
                                  {
                                    staticClass: "text-truncate",
                                    staticStyle: {
                                      "max-width": "110px !important"
                                    }
                                  },
                                  [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "text-nowrap",
                                        staticStyle: {
                                          color: "#1A9167 !important"
                                        },
                                        attrs: {
                                          href: _vm.telUrl(row.item.phone)
                                        }
                                      },
                                      [
                                        _c("v-icon", {
                                          staticClass: "mr-1",
                                          attrs: {
                                            name: "buttons/phone",
                                            size: 12
                                          }
                                        }),
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              _vm.phoneString(row.item.phone)
                                            ) +
                                            "\n            "
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                )
                              ]
                            }
                          },
                          {
                            key: "cell(sex)",
                            fn: function(row) {
                              return [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      typeof row.item.sex === "boolean"
                                        ? row.item.sex
                                          ? "М"
                                          : "Ж"
                                        : ""
                                    ) +
                                    "\n          "
                                )
                              ]
                            }
                          },
                          {
                            key: "cell(level_efficiency)",
                            fn: function(row) {
                              return [
                                _c(
                                  "span",
                                  {
                                    class: [
                                      "custom-tag",
                                      _vm.getLevelEfficiencyStyle(
                                        row.item.level_efficiency
                                      )
                                    ],
                                    attrs: {
                                      id:
                                        "level-efficiency-badge-" + row.item.id
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.getLevelEfficiencyText(
                                            row.item.level_efficiency
                                          )
                                        ) +
                                        "\n              "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                row.item.description !== ""
                                  ? _c(
                                      "b-tooltip",
                                      {
                                        attrs: {
                                          target:
                                            "level-efficiency-badge-" +
                                            row.item.id,
                                          triggers: "hover",
                                          variant: _vm.getLevelEfficiencyStyle(
                                            row.item.level_efficiency
                                          ),
                                          noninteractive: ""
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(row.item.description) +
                                            "\n            "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            }
                          },
                          {
                            key: "cell(employment_type)",
                            fn: function(row) {
                              return [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.getEmploymentTypeText(
                                        row.item.employment_type
                                      )
                                    ) +
                                    "\n          "
                                )
                              ]
                            }
                          },
                          {
                            key: "cell(employment_type_smz)",
                            fn: function(row) {
                              return [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      row.item.employment_type === 1
                                        ? "Да"
                                        : "Нет"
                                    ) +
                                    "\n          "
                                )
                              ]
                            }
                          },
                          {
                            key: "cell(passport_url)",
                            fn: function(row) {
                              return [
                                row.item.passport_url.length > 0
                                  ? _c(
                                      "a",
                                      {
                                        on: {
                                          click: function($event) {
                                            return _vm.downloadFile(
                                              row.item.id,
                                              row.item.passport_url
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c("v-icon", {
                                          style: { color: "#1A9167" },
                                          attrs: {
                                            name: "buttons/passport",
                                            size: 19
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ]
                            }
                          },
                          {
                            key: "cell(active)",
                            fn: function(row) {
                              return [
                                !row.item.active
                                  ? _c("v-icon", {
                                      attrs: { name: "buttons/cross", size: 13 }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                row.item.active
                                  ? _c("v-icon", {
                                      attrs: { name: "buttons/check", size: 14 }
                                    })
                                  : _vm._e()
                              ]
                            }
                          },
                          {
                            key: "cell(action)",
                            fn: function(row) {
                              return [
                                _c(
                                  "b-dropdown",
                                  {
                                    staticClass: "custom-dropdown",
                                    attrs: {
                                      variant: "link",
                                      "toggle-class":
                                        "text-decoration-none box-shadow-none",
                                      "no-caret": ""
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "button-content",
                                          fn: function() {
                                            return [
                                              _c("v-icon", {
                                                attrs: {
                                                  name:
                                                    "buttons/ellipsis_vertical",
                                                  size: 15
                                                }
                                              })
                                            ]
                                          },
                                          proxy: true
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  },
                                  [
                                    _vm._v(" "),
                                    _c(
                                      "b-dropdown-item",
                                      {
                                        attrs: {
                                          variant: "success",
                                          target: "_blank"
                                        },
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.onView(row.item)
                                          }
                                        }
                                      },
                                      [
                                        _c("v-icon", {
                                          staticClass: "mr-2",
                                          attrs: {
                                            name: "buttons/eye",
                                            size: 14
                                          }
                                        }),
                                        _vm._v(
                                          "\n                Смотреть\n              "
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _vm.canEditWorkers()
                                      ? _c(
                                          "b-dropdown-item",
                                          {
                                            attrs: { variant: "primary" },
                                            on: {
                                              click: function($event) {
                                                return _vm.onEdit(row.item)
                                              }
                                            }
                                          },
                                          [
                                            _c("v-icon", {
                                              staticClass: "mr-2",
                                              attrs: {
                                                name: "buttons/edit",
                                                size: 14
                                              }
                                            }),
                                            _vm._v(
                                              "\n                Редактировать\n              "
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "b-dropdown-item",
                                      {
                                        attrs: { variant: "danger" },
                                        on: {
                                          click: function($event) {
                                            return _vm.onRemove(row)
                                          }
                                        }
                                      },
                                      [
                                        _c("v-icon", {
                                          staticClass: "mr-2",
                                          attrs: {
                                            name: "buttons/trash",
                                            size: 14
                                          }
                                        }),
                                        _vm._v(
                                          "\n                Удалить\n              "
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        2417661279
                      )
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "page-pagination" },
                  [
                    _c("pagination-footer", {
                      attrs: {
                        "total-rows": _vm.totalRows,
                        "per-page": _vm.perPage,
                        "current-page": _vm.currentPage,
                        "use-router": ""
                      },
                      on: {
                        "update:perPage": function($event) {
                          _vm.perPage = $event
                        },
                        "update:per-page": function($event) {
                          _vm.perPage = $event
                        },
                        "update:currentPage": function($event) {
                          _vm.currentPage = $event
                        },
                        "update:current-page": function($event) {
                          _vm.currentPage = $event
                        },
                        "page-click": _vm.onPagination,
                        "per-page-change": _vm.onPerPageChange
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "footer-update",
                            fn: function() {
                              return [
                                _vm.selected.length > 0
                                  ? _c("span", { staticClass: "mr-2" }, [
                                      _vm._v("\n              Выбрано: "),
                                      _c("b", [
                                        _vm._v(_vm._s(_vm.selected.length))
                                      ])
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.selected.length > 0
                                  ? _c("span", {
                                      staticClass: "vertical-divider"
                                    })
                                  : _vm._e()
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        false,
                        3354599052
                      )
                    })
                  ],
                  1
                )
              ]
            : _c(
                "div",
                { staticClass: "empty-state-container" },
                [
                  _c("v-icon", {
                    attrs: { name: "navbar/empty_table", size: 90 }
                  }),
                  _vm._v(" "),
                  _c("h5", [
                    _vm._v(
                      _vm._s(
                        _vm.isFiltered
                          ? "Нет данных соответствующих фильтрам."
                          : "Нет созданных исполнителей."
                      )
                    )
                  ]),
                  _vm._v(" "),
                  !_vm.isFiltered
                    ? _c(
                        "div",
                        [
                          _c("p", [
                            _vm._v("Создайте нового исполнителя прямо сейчас")
                          ]),
                          _vm._v(" "),
                          _vm.canEditWorkers()
                            ? _c(
                                "b-btn",
                                {
                                  staticClass: "custom-btn-primary mt-1",
                                  attrs: { disabled: _vm.isBusy },
                                  on: {
                                    click: function($event) {
                                      return _vm.onCreate()
                                    }
                                  }
                                },
                                [
                                  _c("v-icon", {
                                    staticClass: "mr-1",
                                    attrs: { name: "buttons/plus", size: 12 }
                                  }),
                                  _vm._v(
                                    "\n          Новый исполнитель\n        "
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
        ],
        2
      ),
      _vm._v(" "),
      _c("dynamic-tables", {
        attrs: {
          "storage-key": "workers_columns",
          "sidebar-fields": "sidebar-fields",
          "fields-model": _vm.fields,
          fieldKey: "id"
        },
        on: {
          "update:fieldsModel": function($event) {
            _vm.fields = $event
          },
          "update:fields-model": function($event) {
            _vm.fields = $event
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-05925b76", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05925b76","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Workers/WorkerTable.vue
// module id = null
// module chunks = 